import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "input", "loading"]

  connect() {
    this.timeout = null

    this.frameLoaded = this.frameLoaded.bind(this)
    document.addEventListener("turbo:frame-load", this.frameLoaded)
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", this.frameLoaded)
  }

  frameLoaded(event) {
    if (event.target.id === "shows_search_results") {
      this.hideLoading()
    }
  }

  search() {
    clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      if (this.inputTarget.value.trim().length < 3) {
        this.hideLoading()
        return
      }

      this.showLoading()
      this.formTarget.requestSubmit()
    }, 300)
  }

  showLoading() {
    this.loadingTarget.classList.remove("hidden")
  }

  hideLoading() {
    this.loadingTarget.classList.add("hidden")
  }
}
